import { Injectable } from '@angular/core';
import {HttpService} from '@api/http/http.service';
import {ANALYTICS_ROUTE} from '@api/http/http-routes';
import {AnalyticsViewType} from '@api/models/analytics/analytics-view-type';
import {IDefaultResponse} from '@api/models/default-response/response';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsHttpService {

  constructor( private http: HttpService ) { }

  public async patchAddView(id: string, type: AnalyticsViewType): Promise<IDefaultResponse> {
    return this.http.patch<IDefaultResponse>([ANALYTICS_ROUTE, 'add-view', type, id]).toPromise();
  }
}
